// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xGoogleAnalyticsState } from "@guestsupply/App/Store/Reducers";
import { getDataLayer } from "@guestsupply/App/Utilities/DataLayer";
import { GOOGLE_EVENTS } from "@guestsupply/XDL/constants";
import { parseProductCategories } from "@guestsupply/XDL/Utilities";
import { addToEndOfChain, ApiHandler } from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentBillToState } from "@insite/client-framework/Store/Data/BillTos/BillTosSelectors";
import { chain as SendRmaRequest } from "@insite/client-framework/Store/Pages/RequestRma/Handlers/SendRmaRequest";

export const XngGaRMARequest: ApiHandler<any, any> = props => {
    const state = props.getState() as xGoogleAnalyticsState;
    const session = getSession(state);
    const currentBillTo = getCurrentBillToState(state).value;
    const cartLines = state.pages.requestRma.orderLines;
    const locationId = session?.pickUpWarehouse?.id;

    if (state.xGoogleAnalytics.includeRMARequestEvent) {
        const dataLayer = getDataLayer();

        if (!dataLayer) {
            return;
        }

        const googleAnalyticsData = {
            event: GOOGLE_EVENTS.RMA_REQUEST,
            ecommerce: {
                items: cartLines?.map(cartItem => ({
                    item_id: cartItem.productErpNumber,
                    item_name: cartItem.productName || cartItem.shortDescription,
                    index: cartItem.lineNumber,
                    affiliation: currentBillTo?.companyName,
                    item_brand: cartItem.brand?.name,
                    location_id: locationId,
                    price: cartItem.unitNetPrice,
                    quantity: cartItem.qtyOrdered,
                    return_reason: cartItem.returnReason,
                    ...parseProductCategories(cartItem?.properties?.categories, false),
                })),
                brand_code: currentBillTo?.properties?.brand,
                exclusive: currentBillTo?.properties?.exclusive,
                group_descr: currentBillTo?.properties?.groupDescription,
            },
        };

        dataLayer.push(googleAnalyticsData);
    }
};

const _GaRMARequest = XngGaRMARequest as any;
addToEndOfChain(SendRmaRequest, _GaRMARequest);
